import axios from 'axios'

const global = axios.create()

export default global
